"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _icons = require("@material-ui/icons");
var _MenuRounded = _interopRequireDefault(require("@material-ui/icons/MenuRounded"));
var _HideOnScroll = _interopRequireDefault(require("./HideOnScroll"));
var _mobileDefaultBarStyles = _interopRequireDefault(require("./mobileDefaultBarStyles"));
var _userUtils = require("./userUtils");
var _headerContext = require("./headerContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function MobileDefaultBar(_ref) {
  let {
    username,
    email,
    onClickHome,
    menuItems,
    drawerItems,
    hiddenMenu,
    logo,
    logoImg,
    navigateMenu,
    isFullHeight
  } = _ref;
  const classes = (0, _mobileDefaultBarStyles.default)();
  const initials = (0, _userUtils.getInitials)(username);
  function menuDrawer(state, actions) {
    if (!navigateMenu) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MenuRounded.default, {
      className: classes.iconMenu,
      onClick: actions.openNavigateMenu
    }), /*#__PURE__*/_react.default.createElement(_core.Drawer, {
      className: classes.drawer,
      variant: "temporary",
      anchor: "left",
      open: state.openNavigateMenu,
      classes: {
        paper: classes.drawerPaper
      },
      onClose: actions.closeNavigateMenu
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.drawerMenuHeader
    }, /*#__PURE__*/_react.default.createElement(_icons.CloseSharp, {
      className: classes.closeIcon,
      onClick: actions.closeNavigateMenu
    })), /*#__PURE__*/_react.default.createElement(_Divider.default, null), drawerItems?.map(item => /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      onClick: () => {
        actions.closeNavigateMenu();
        item.onClick();
      },
      key: item.label,
      dense: true,
      className: isFullHeight ? classes.menuItemFull : classes.menuItemDrawer
    }, item.nodeIcon, item.label))));
  }
  function renderAvatar(state, actions) {
    if (hiddenMenu) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      "aria-label": "Perfil do Usu\xE1rio",
      className: navigateMenu ? classes.avatarMenu : classes.avatar,
      onClick: actions.openDrawer
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, null, initials)), /*#__PURE__*/_react.default.createElement(_core.Drawer, {
      className: classes.drawer,
      variant: "temporary",
      anchor: "right",
      open: state.openDrawer,
      classes: {
        paper: classes.drawerPaper
      },
      onClose: actions.closeDrawer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.drawerHeader
    }, /*#__PURE__*/_react.default.createElement(_icons.CloseSharp, {
      className: classes.closeIcon,
      onClick: actions.closeDrawer
    })), /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      className: classes.menuItem,
      style: {
        height: '44px',
        marginTop: '16px'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, null, initials), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.listUserStyle
    }, (0, _userUtils.listUser)(username, 24), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.secondaryText,
      style: {
        marginBottom: '14px'
      }
    }, (0, _userUtils.listUser)(email, 24)))), menuItems.map(item => /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      onClick: item.onClick,
      key: item.label,
      dense: true
    }, item.nodeIcon, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.primaryText,
      style: {
        fontSize: '14px'
      }
    }, item.label))), /*#__PURE__*/_react.default.createElement(_Divider.default, {
      style: {
        marginTop: 8
      }
    })));
  }
  return /*#__PURE__*/_react.default.createElement(_headerContext.HeaderContext.Consumer, null, _ref2 => {
    let {
      state,
      actions
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_HideOnScroll.default, null, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
      className: classes.header
    }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
      className: navigateMenu ? classes.toolbarMenu : classes.toolbar
    }, menuDrawer(state, actions), /*#__PURE__*/_react.default.createElement(_core.Button, {
      disableRipple: true,
      className: navigateMenu ? classes.logoMenu : classes.logo,
      onClick: onClickHome
    }, logo && /*#__PURE__*/_react.default.createElement("img", {
      src: logo,
      alt: "logo"
    }), logoImg && logoImg), renderAvatar(state, actions))));
  });
}
MobileDefaultBar.propTypes = {
  username: _propTypes.default.string.isRequired,
  email: _propTypes.default.string,
  onClickHome: _propTypes.default.func.isRequired,
  isFullHeight: _propTypes.default.bool,
  drawerItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired),
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired).isRequired,
  hiddenMenu: _propTypes.default.bool,
  logo: _propTypes.default.element,
  navigateMenu: _propTypes.default.bool,
  logoImg: _propTypes.default.node
};
MobileDefaultBar.defaultProps = {
  email: 'email@saraivaeducacao.com.br',
  hiddenMenu: false,
  navigateMenu: false,
  drawerItems: null,
  logo: null,
  logoImg: null,
  isFullHeight: false
};
var _default = exports.default = MobileDefaultBar;